import { FC } from 'react';
import { Card } from 'react-bootstrap';
import { HELP_ROUTE } from 'components/help/constants';
import Link from 'components/common/Link/Link';

interface AboutScrubbingProps {
  scrubbingfilterRules: JSX.Element;
}

const AboutScrubbing: FC<AboutScrubbingProps> = ({ scrubbingfilterRules }: AboutScrubbingProps) => (
  <Card>
    <Card.Body>
      <p>
        Data scrubbing allows you to remove passwords or other sensitive information by rewriting or removing portions
        of any log line.
      </p>
      <p>Scrubbing is the first step of log processing, where the sensitive information is matched and discarded.</p>
      <span>To scrub a portion of a log line, create a new scrubbing filter and specify:</span>
      <ul>
        <li>A filter to match a subset of logs or log lines</li>
        <li>A regex expression to isolate the sensitive info</li>
        <li>Some text to replace the isolated info with</li>
      </ul>
      {scrubbingfilterRules}
      <Link href={HELP_ROUTE.HELP_LOG_PROCESSING_SCRUBBING} openInNewTab className="link">
        Learn more about scrubbing...
      </Link>
    </Card.Body>
  </Card>
);

export default AboutScrubbing;
